module.exports = __webpack_public_path__ + "img/permission.3aba50d2.svg";